import React, {useEffect, useState} from 'react';
import {Form, Grid, Header, Segment, Table} from 'semantic-ui-react';
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {ToasterConfig} from "../../../../config/ToasterConfig";
import useBusinessUnitService from "../../../../services/backoffice/hooks/useBusinessUnitService";
import {ShortDto} from "../../../../models/short-dto";
import {UnidadeDeNegociosFilter} from "../../../../filters/unidade-de-negocios-filter";
import useClientService from "../../../../services/backoffice/hooks/useClientService";
import useFleetService from "../../../../services/backoffice/hooks/useFleetService";
import {CreateFleetRequest} from "../../../../models/requests/create-fleet-request";

const CreateFleetPage = () => {
    const [fleet, setFleet] = useState<Partial<CreateFleetRequest>>({});
    const navigate = useNavigate();
    const [clientes, setClients] = useState<ShortDto[]>([])
    const [businessUnits, setBusinessUnits] = useState<ShortDto[]>([])
    const {getAllGetUnitsShortDto} = useBusinessUnitService();
    const {getAllClientsShortDto} = useClientService();
    const {createFleet} = useFleetService();
    const [clientId, setClientId] = useState<string>('');

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setFleet((prevUser) => ({
            ...prevUser,
            [name]: value,
        }));
    };

    useEffect(() => {
        function ListClientes() {
            getAllClientsShortDto().then((response) => {
                setClients(response);
            })
        }

        ListClientes()
    }, [])

    useEffect(() => {
        if (clientId) {
            const filter: UnidadeDeNegociosFilter = {clientId};
            getAllGetUnitsShortDto(filter).then((response) => {
                setBusinessUnits(response);
            })
        }
    }, [clientId]);


    const handleSubmit = async () => {
        try {
            await createFleet(fleet)
            navigate('/backoffice/fleets/')
            toast.success('Operação criada com sucesso', ToasterConfig.success);
        } catch (error) {
        }
    };

    return (
        <div>
            <Grid.Column mobile={16} tablet={8} computer={6}>
                <Header as="h3" textAlign="center" color={'green'}>
                    Operação / Adicionar
                </Header>
                <Segment>
                    <Form onSubmit={handleSubmit}>

                        <Form.Input
                            label="Nome da Operação"
                            name="operationName"
                            type="text"
                            placeholder="Nome da operação"
                            value={fleet.operationName}
                            onChange={handleInputChange}
                            required
                        />


                        <Form.Select
                            label={'Cliente ao qual a Operação pertence'}
                            options={clientes}
                            placeholder='Selecione uma opção'
                            value={fleet?.clientId || ''}
                            required
                            search
                            clearable
                            onChange={(e: any, data: any) => {
                                const selectedValue = data.value;
                                setClientId(selectedValue);
                                setFleet(prevUnit => ({...prevUnit, clientId: selectedValue}));
                            }}
                        />

                        <Form.Select
                            label={'Unidade de Negócio da Operação'}
                            options={businessUnits}
                            placeholder='Selecione uma opção'
                            value={fleet?.businessUnitId || ''}
                            required
                            search
                            clearable
                            onChange={(e: any, data: any) => {
                                const selectedValue = data.value;
                                setFleet(prevUnit => ({...prevUnit, businessUnitId: selectedValue}));
                            }}
                            disabled={!fleet?.clientId}

                        />


                        <Table.Row>
                            <Table.HeaderCell>
                                <Form.Button content="Voltar"
                                             icon='arrow left'
                                             onClick={() => navigate('/backoffice/fleets/')} grey/>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Form.Button content="Adicionar"
                                             type={"submit"}
                                             icon='save'
                                             color={"green"}/>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Form>
                </Segment>
            </Grid.Column>
        </div>
    );
};

export default CreateFleetPage;
